const boosterGetters = {
  getBoosterFields: (state) => state.boosterFields,
  getBoosters: (state) => state.boostersList,
  getInactiveBoosters: (state) => state.inactiveBoosters,
  getBoostersPreview: (state) => state.boostersPreview,
  getBoosterCCSDocuments: (state) => state.boosterCCSDocuments,
  getBooster: (state) => state.booster,
  getBoosterMessage: (state) => state.boosterMessage
}

export { boosterGetters }
